import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MarkdownModule } from 'ngx-markdown';
import { ExcursionRoutingModule } from './excursion-routing.module';
import { SharedModule } from '../shared/shared.module';

//PIPES
import { DateMatchPipe } from '../shared/pipes/date-match.pipe';

import { ExcursionsComponent } from './excursions/excursions.component';
import { ExcursionDetailComponent } from './excursion-detail/excursion-detail.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ExcursionsEditReviewsEditComponent } from './excursions-edit-reviews-edit/excursions-edit-reviews-edit.component';

@NgModule({
	declarations: [
		ExcursionsComponent,
		ExcursionDetailComponent,
		ExcursionsEditReviewsEditComponent,
		//PIPES
		DateMatchPipe
	],
	imports: [
		CommonModule,
		ExcursionRoutingModule,
		//BsDatepickerModule.forRoot(),
		ModalModule.forRoot(),
		SharedModule,
		SharedComponentsModule,
		MarkdownModule.forChild()
	]
})
export class ExcursionModule { }
